import styled, { css } from 'styled-components';

export const P = styled.p`
  line-height: 1.5rem;
  color: var(--pd-light-dark-color);
  white-space: pre-wrap;
  text-align: left;
  ${(props) =>
    props.maxLines &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: ${props.maxLines}; /* number of lines to show */
      -webkit-box-orient: vertical;
    `}
`;
